module.exports = __webpack_public_path__ + "img/customer.e29675ec.png";